module.exports = __webpack_public_path__ + "img/20190918172048743.8998ecc7.jpg";